"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return HookLog;
    }
});
const _Hook = /*#__PURE__*/ _interop_require_default(require("~/models/Hook"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
const _utils = require("~/utils");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let HookLog = class HookLog {
    static async list(context, param, { limit = 25, offset = 0 }, ncMeta = _Noco.default.ncMeta) {
        const hookLogs = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.HOOK_LOGS, _extends({
            condition: {
                fk_hook_id: param.fk_hook_id
            }
        }, process.env.NC_AUTOMATION_LOG_LEVEL === 'ERROR' && {
            xcCondition: {
                error_message: {
                    neq: null
                }
            }
        }, {
            orderBy: {
                created_at: 'desc'
            },
            limit,
            offset
        }));
        return hookLogs == null ? void 0 : hookLogs.map((h)=>new HookLog(h));
    }
    static async insert(context, hookLog, ncMeta = _Noco.default.ncMeta) {
        if (process.env.NC_AUTOMATION_LOG_LEVEL === 'OFF') {
            return;
        }
        const insertObj = (0, _extractProps.extractProps)(hookLog, [
            'source_id',
            'base_id',
            'fk_hook_id',
            'type',
            'event',
            'operation',
            'test_call',
            'payload',
            'conditions',
            'notification',
            'error_code',
            'error_message',
            'error',
            'execution_time',
            'response',
            'triggered_by'
        ]);
        const hook = await _Hook.default.get(context, hookLog.fk_hook_id, ncMeta);
        if (!hookLog.source_id) {
            insertObj.source_id = hook.source_id;
        }
        if (typeof insertObj.notification === 'object') {
            insertObj.notification = JSON.stringify(insertObj.notification);
        }
        insertObj.execution_time = parseInt(insertObj.execution_time) || 0;
        return await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.HOOK_LOGS, insertObj);
    }
    static async count(context, { hookId }, ncMeta = _Noco.default.ncMeta) {
        var _ref;
        var _this;
        const qb = ncMeta.knex(_globals.MetaTable.HOOK_LOGS);
        if (context.workspace_id) {
            qb.where(`${_globals.MetaTable.HOOK_LOGS}.fk_workspace_id`, context.workspace_id);
        }
        if (context.base_id) {
            qb.where(`${_globals.MetaTable.HOOK_LOGS}.base_id`, context.base_id);
        }
        if (hookId) {
            qb.where(`${_globals.MetaTable.HOOK_LOGS}.fk_hook_id`, hookId);
        }
        if (process.env.NC_AUTOMATION_LOG_LEVEL === 'ERROR' || _utils.isOnPrem && process.env.NC_AUTOMATION_LOG_LEVEL !== 'OFF') {
            qb.whereNotNull(`${_globals.MetaTable.HOOK_LOGS}.error_message`);
        }
        return (_ref = (_this = await qb.count('id', {
            as: 'count'
        }).first()) == null ? void 0 : _this.count) != null ? _ref : 0;
    }
    constructor(hookLog){
        Object.assign(this, hookLog);
    }
};
